/* eslint-disable import/prefer-default-export */
import type { VariantPickerModel } from 'autogen/swagger/all';
import { useGetVariantColorPickerForPdpQuery, useGetVariantPickerForPlpQuery } from 'autogen/swagger/all/hooks';
import { type ReactNode, createContext, useState } from 'react';
import { useVariantPickerStore } from '../store';

type SelectionCallbackContextType = (productId: number) => void;
export const SelectionCallbackContext = createContext<SelectionCallbackContextType>({} as SelectionCallbackContextType);

function SelectedItemProvider({
    model,
    isPDPRequest,
    children
}: {
    model: VariantPickerModel;
    isPDPRequest: boolean;
    children: ReactNode;
}) {
    const [PDPSelectedId, setPDPSelectedItem] = useState<number>(model.productId);
    const [PLPSelectedId, setPLPSelectedItem] = useState<number>(model.productId);
    const { setModel } = useVariantPickerStore();

    useGetVariantPickerForPlpQuery(
        { id: PLPSelectedId },
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            initialData: model,
            onSuccess: (data) => {
                setModel(data);
            }
        }
    );

    useGetVariantColorPickerForPdpQuery(
        { id: PDPSelectedId },
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            initialData: model,
            onSuccess: (data) => {
                setModel(data);
            }
        }
    );

    function onSelectionCallback(productId: number) {
        if (isPDPRequest) {
            setPDPSelectedItem(productId);
        } else {
            setPLPSelectedItem(productId);
        }
    }

    return (
        <SelectionCallbackContext.Provider value={onSelectionCallback}>{children}</SelectionCallbackContext.Provider>
    );
}

export default SelectedItemProvider;
